export const uaVersionListConstants = {
  UA_VERSION_LIST_LOADING: "UA_VERSION_LIST_LOADING",
  UA_VERSION_LIST_SUCCESS: "UA_VERSION_LIST_SUCCESS",
  UA_VERSION_LIST_FAILURE: "UA_VERSION_LIST_FAILURE",
};

export const uaVersionUploadConstants = {
  UA_VERSION_UPLOAD_LOADING: "UA_VERSION_UPLOAD_LOADING",
  UA_VERSION_UPLOAD_SUCCESS: "UA_VERSION_UPLOAD_SUCCESS",
  UA_VERSION_UPLOAD_FAILURE: "UA_VERSION_UPLOAD_FAILURE",
};

export const uaVersionConstants = {
  UA_VERSION_LOADING: "UA_VERSION_LOADING",
  UA_VERSION_SUCCESS: "UA_VERSION_SUCCESS",
  UA_VERSION_FAILURE: "UA_VERSION_FAILURE",
};

export const uaVersionDeleteConstants = {
  UA_VERSION_DELETE_LOADING: "UA_VERSION_DELETE_LOADING",
  UA_VERSION_DELETE_SUCCESS: "UA_VERSION_DELETE_SUCCESS",
  UA_VERSION_DELETE_FAILURE: "UA_VERSION_DELETE_FAILURE",
};
